module.exports = __webpack_public_path__ + "static/01-253d0291e66d4605d782cd2d12edbdda.jpg";